import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as actions from '../store/delivery.actions';

@Injectable()
export class DeliveryOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(actions.loadData());
    return of(true);
  }
}
